import React from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'

import { SectionLink } from '../../../entities/Page'

import './LinkItem.css'

const LinkItem = ({ item, className }) => {
    const slug = item.slug || item.id
    const link = item.applicationLink ? item.applicationLink : `/strana/sekcija/${slug}`
    const target = item.applicationLink ? '_blank' : ''

    return (
        <a
            href={link}
            className={`link-list-item link-list-item--${className}`}
            id={slug}
            name={item.name}
            target={target}
        >
            <span className="link-list-item__title">{item.title}</span>
            <span className="link-list-item__arrow" />
        </a>
    )
}

LinkItem.propTypes = {
    item: PropTypes.instanceOf(SectionLink).isRequired,
    className: PropTypes.string
}

export default withRouter(LinkItem)
